import React from 'react';
import { useIntl } from 'react-intl';

import ContactUs from '../../Components/Entities/ContactUs/ContactUs';
import MetaTags from '../../Components/MetaTags/MetaTags';
import ListOfUiSections from '../../Components/UiSection/ListOfUiSections';
import useSpace from '../../Hooks/useSpace';

function PageAbout() {
  const { space } = useSpace();
  const intl = useIntl();

  return (
    <>
      <MetaTags
        title={intl.formatMessage(
          { id: 'META_TAGS.PAGES_TITLES.ABOUT' },
          { spaceName: space.name },
        )}
        description={space.description}
        pictureUrl={space.picture_to_share_url}
      />

      <ListOfUiSections page="about" />

      <ContactUs space={space} />
    </>
  );
}

export default PageAbout;
